import { Pagination, SortedTable, TableBar } from '@ingrid/luterkort-react';

import { Direction, usePagination } from '~src/main/hooks/usePagination';

export function ListTableBar() {
  const { direction, setDirection } = usePagination();

  return (
    <TableBar sticky>
      <SortedTable.Provider
        onSortValueChange={sortValue => setDirection(sortValue.sort as Direction)}
        sortValue={{ name: direction, sort: direction }}
      >
        <Pagination sortName={direction} />
      </SortedTable.Provider>
    </TableBar>
  );
}
